<ng-content></ng-content>

<ng-template #modalItems let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ id ? 'Meus' : 'Incluir' }} Itens</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body p-0 bg-white custom-modal-scroll-container">
		@if (editable) {
			<div class="d-flex justify-content-between bg-gray-100 p-3">
				<div class="text-sm-start text-center">
					<button class="btn btn-sm btn-link rounded-xl fw-600" (click)="downloadSheetModel()">
						<fa-icon class="pe-1" icon="download"></fa-icon>
						Baixar planilha de importação (XLSX)
					</button>
				</div>

				<div>
					<input type="file" #fileImportItem (change)="readSheetForImportItems($event)" style="display: none" />
					<button *permissions="'planning.item.manage'"
						class="btn btn-sm btn-outline-primary me-md-3 me-0 rounded-xl fw-600"
						(click)="fileImportItem.click()"
						[disabled]="readSheetForImportItemsLoading || demand?.statusCanceled">
						<fa-icon class="pe-1" icon="upload"></fa-icon>
						{{ readSheetForImportItemsLoading ? 'Processando, aguarde...' : 'Importar via Planilha (XLSX)' }}
					</button>

					<button *permissions="'planning.item.create'"
						class="btn btn-sm btn-outline-primary rounded-xl fw-600"
						(click)="addFormItem()"
						[disabled]="readSheetForImportItemsLoading || demand?.statusCanceled || bestTechnicalItemLimitReached"
						[title]="bestTechnicalItemLimitReached ? 'No julgamento por melhor técnica ou conteúdo artístico o processo deve ter um único item' : ''">
						<fa-icon class="pe-1" icon="plus"></fa-icon>
						Adicionar {{ itemsControl.controls.length > 1 ? 'outro' : '' }} Item
					</button>
				</div>
			</div>
		}

		@if (listableItems) {
			@if (isBatchBidType) {
				<div class="p-3 pb-0">
					<ul ngbNav #batchNav="ngbNav" [(activeId)]="activeTabItemsModal" class="nav-tabs">
						<li [ngbNavItem]="'items'">
							<button ngbNavLink>Itens</button>
							<ng-template ngbNavContent>
								<ng-container *ngTemplateOutlet="listableItemsContent"></ng-container>
							</ng-template>
						</li>
						<li [ngbNavItem]="'batches'">
							<button ngbNavLink>Lotes</button>
							<ng-template ngbNavContent>
								@if (!noticeSessionId) {
									<div class="p-5">
										<app-empty-data message="Para gerenciar lotes, primeiro configure a sessão do edital."></app-empty-data>
									</div>
								} @else if (noticeSessionBatchesLoading) {
									<div class="p-5">
										<app-pre-loading></app-pre-loading>
									</div>
								} @else {
									@if (noticeSessionBatches.length === 0) {
										<div class="p-5">
											<app-empty-data message="Nenhum lote cadastrado para essa sessão.">
												@if (editable) {
													<div class="d-flex justify-content-center pt-3">
														<button *permissions="'planning.batch.create'"
															class="btn btn-primary fw-600"
															(click)="createNoticeSessionBatch()"
															[disabled]="
																noticeSessionBatchSubmitting ||
																demand?.noticeSession?.statusOpened ||
																demand?.noticeSession?.statusClosed
															">
															<app-label-loading-dots
																[loading]="noticeSessionBatchSubmitting"
																label="Cadastrar lote"></app-label-loading-dots>
														</button>
													</div>
												}
											</app-empty-data>
										</div>
									} @else {
										<ul class="list-group list-group-flush">
											<li class="list-group-item bg-gray-100 d-flex justify-content-between align-items-center">
												<small class="text-muted">
													Total de
													<b>{{ noticeSessionBatches.length }}</b>
													lote(s)
												</small>
												<div class="d-flex gap-2">
													<button class="btn btn-sm btn-icon" (click)="fetchNoticeSessionBatches()">
														<fa-icon icon="refresh"></fa-icon>
													</button>
													@if (editable) {
														<button *permissions="'planning.batch.create'"
															class="btn btn-sm btn-indigo fw-600"
															(click)="createNoticeSessionBatch()"
															[disabled]="
																noticeSessionBatchSubmitting ||
																demand?.noticeSession?.statusOpened ||
																demand?.noticeSession?.statusClosed
															">
															<app-label-loading-dots
																[loading]="noticeSessionBatchSubmitting"
																label="Cadastrar"></app-label-loading-dots>
														</button>
													}
												</div>
											</li>
											@for (batch of noticeSessionBatches; track batch.id) {
												<li class="list-group-item d-flex justify-content-between align-items-center">
													<div class="pe-3">
														<small class="text-muted d-block">{{ batch.externalCode }}</small>
														<p class="mb-0 fw-700">{{ batch.description }}</p>
													</div>
													@if (editable) {
														<div class="d-flex gap-2">
															<button *permissions="'planning.batch.update'" class="btn btn-sm btn-link text-dark" (click)="editNoticeSessionBatch(batch)">
																<fa-icon icon="edit"></fa-icon>
															</button>
															<button *permissions="'planning.batch.update'" class="btn btn-sm btn-link text-danger" (click)="removeNoticeSessionBatch(batch)">
																<fa-icon icon="trash"></fa-icon>
															</button>
														</div>
													}
												</li>
											}
										</ul>
									}
								}
							</ng-template>
						</li>
					</ul>
				</div>

				<div class="px-3 pb-3">
					<div class="border border-top-0 bg-white" [ngbNavOutlet]="batchNav"></div>
				</div>
			} @else {
				<ng-container *ngTemplateOutlet="listableItemsContent"></ng-container>
			}

			<ng-template #listableItemsContent>
				@if (demandIntentDocumentItem$ | async; as demandIntentDocumentItemPageable) {
					<ul class="list-group list-group-flush">
						@if (demandIntentDocumentItemPageable.empty) {
							<div class="p-5">
								<app-empty-data message="Nenhum item informado, antes de publicar informe pelo menos 1 item"></app-empty-data>
							</div>
						} @else {
							<li class="list-group-item bg-gray-100">
								<div class="row pt-3">
									<div class="col-md-12 mb-3">
										<div class="input-group">
											<div class="form-floating">
												<input
													type="text"
													id="itemTerm"
													placeholder="Descrição"
													class="form-control"
													[(ngModel)]="demandIntentDocumentItemService.searchTerm.term" />
												<label for="itemTerm">Descrição</label>
											</div>

											<button class="btn btn-primary border-start-0 fw-600" (click)="fetchDemandIntentDocumentItemPageable()">
												<fa-icon class="pe-2" icon="search"></fa-icon>
												<div class="d-sm-block d-none">Pesquisar</div>
											</button>
										</div>
									</div>
								</div>
							</li>
						}
						@for (item of demandIntentDocumentItemPageable.content; track item.id; let i = $index; let l = $last) {
							<li class="list-group-item d-flex align-items-center bg-white" [ngClass]="{ 'border border-bottom-1 border-top-0': l }">
								<b style="width: 60px" class="text-center pe-1">
									{{ (demandIntentDocumentItemPageable.page ?? 0) * (demandIntentDocumentItemPageable.size ?? 10) + i + 1 }}
								</b>
								<div class="w-100">
									<div class="pb-2">
										<small class="badge badge-sm text-bg-light border rounded-xl fw-700" style="margin-left: -3px">
											{{ item.total | number }}
											{{
												(item.total > 1
													? label.fromProductUnit(item.productUnit)?.title
													: label.fromProductUnit(item.productUnit)?.label
												) | uppercase
											}}
										</small>
										<small class="badge badge-sm text-bg-light border rounded-xl fw-700">
											Valor unitário {{ item.amount | currency: 'BRL' }}
										</small>
										<small class="badge badge-sm text-bg-light border rounded-xl fw-700">
											Total {{ item.amount * item.total | currency: 'BRL' }}
										</small>
									</div>
									<p class="mb-0 fw-700">{{ item.productName | uppercase }}</p>
									<small class="d-inline-block w-100">{{ item.productDescription | uppercase }}</small>
									@if (quotaTypeLabel(item); as quotaLabel) {
										<!-- Spec 045: o tipo de cota ME/EPP do item e a ligação da reservada com a principal. -->
										<div class="d-flex gap-2 align-items-center flex-wrap mt-1" [attr.data-testid]="'item-quota-' + item.id">
											<small class="badge badge-sm text-bg-info">{{ quotaLabel }}</small>
											@if (quotaRelation(item, demandIntentDocumentItemPageable.content); as relation) {
												<small class="text-muted">{{ relation }}</small>
											}
										</div>
									}
									<div class="d-flex gap-2 align-items-center flex-wrap">
										<small class="badge badge-sm text-bg-light border">{{ item.unitName | uppercase }}</small>
									</div>
								</div>
								@if (isBatchBidType) {
									<div class="me-2" style="width: 260px">
										<select
											class="form-select form-select-sm"
											[ngModel]="item.batchId ?? ''"
											[ngModelOptions]="{ standalone: true }"
											[disabled]="
												item?.deleting ||
												item?.submitted ||
												demand?.publishStatus === DemandIntentDocumentPublishStatus.DONE ||
												demand?.statusCanceled ||
												demand?.noticeSession?.statusOpened ||
												demand?.noticeSession?.statusClosed
											"
											(ngModelChange)="updateItemBatch(item, $event || null)">
											<option value="">Sem lote</option>
											@for (batch of noticeSessionBatches; track batch.id) {
												<option [value]="batch.id">{{ batch.description }}</option>
											}
										</select>
									</div>
								}
								<div class="text-start">
									<div class="dropdown no-caret" ngbDropdown container="body">
										<a
											class="btn btn-icon btn-transparent-dark dropdown-toggle"
											ngbDropdownToggle
											data-cy="actions"
											role="button"
											aria-haspopup="true"
											aria-expanded="false">
											<fa-icon class="text-dark" icon="ellipsis-vertical"></fa-icon>
										</a>

										<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu aria-labelledby="actions">
											<button *permissions="'planning.item.update'"
												class="dropdown-item"
												[disabled]="
													item?.deleting ||
													item?.submitted ||
													demand?.publishStatus === DemandIntentDocumentPublishStatus.DONE ||
													demand?.statusCanceled
												"
												(click)="editFormItem(item)">
												<div class="dropdown-item-icon"><i-feather name="edit"></i-feather></div>
												Editar
											</button>
											<button *permissions="'planning.item.delete'"
												class="dropdown-item text-danger"
												[disabled]="
													item?.deleting ||
													item?.submitted ||
													demand?.publishStatus === DemandIntentDocumentPublishStatus.DONE ||
													demand?.statusCanceled
												"
												(click)="delFormItem(i, item, demandIntentDocumentItemPageable)">
												<div class="dropdown-item-icon"><i-feather name="trash-2"></i-feather></div>
												<app-label-loading-dots [loading]="item?.deleting" label="Deletar"></app-label-loading-dots>
											</button>
										</div>
									</div>
								</div>
							</li>
						}
					</ul>

					@if (!demandIntentDocumentItemPageable.empty) {
						<div class="modal-footer flex-column gap-2 align-items-stretch">
							<div class="d-flex justify-content-start align-items-center w-100 gap-3">
								<small class="text-muted">Total de {{ demandIntentDocumentItemPageable.totalElements | number }} registro(s)</small>
								<ngb-pagination
									[rotate]="true"
									[maxSize]="5"
									[pageSize]="demandIntentDocumentItemPageable.size"
									[page]="demandIntentDocumentItemPageable.page + 1"
									[collectionSize]="demandIntentDocumentItemPageable.totalElements"
									(pageChange)="fetchDemandIntentDocumentItemPageable($event - 1, demandIntentDocumentItemParams)"></ngb-pagination>
							</div>
							<div class="d-flex justify-content-end align-items-center w-100 gap-3 pe-3">
								<small class="text-muted">Subtotal</small>
								<b>
									@if (itemsSubtotalLoading | async) {
										Aguarde...
									} @else {
										{{ itemsSubtotal | currency: 'BRL' }}
									}
								</b>
							</div>
						</div>
					}
				} @else {
					<app-pre-loading></app-pre-loading>
				}
			</ng-template>
		} @else {
			<div class="d-flex justify-content-between align-items-center ps-3 pt-2 pb-2">
				<div class="d-flex flex-row align-items-center">
					<small class="text-muted ps-0 pe-3">
						Total de
						<b>{{ itemsControl.controls.length | number }}</b>
						{{ itemsControl.controls.length > 1 ? 'formulários' : 'formulário' }}
					</small>
				</div>
			</div>

			<form [formGroup]="formItems">
				<div ngbAccordion #accordionItems="ngbAccordion" [closeOthers]="true" class="scroll-content-items" #contentFormItems>
					@for (itemFormGroup of itemsControl.controls; track itemFormGroup; let iItem = $index; let last = $last) {
						<div
							[ngClass]="'accordion-item-' + iItem"
							ngbAccordionItem
							(click)="ScrollUtil.scrollIntoViewToClassName('accordion-item-' + iItem)"
							[collapsed]="!last">
							<div ngbAccordionHeader ngbAccordionToggle class="accordion-button justify-content-between cursor-pointer">
								@if (!demandIntentDocumentItem) {
									<button *permissions="'planning.item.delete'" class="btn me-3 btn-sm btn-icon text-danger" (click)="delFormItem(iItem); $event.stopImmediatePropagation()">
										<fa-icon icon="trash"></fa-icon>
									</button>
								}

								<div class="m-0 d-flex align-items-center flex-column w-100">
									<div class="col-md-12 text-wrap">
										<p class="mb-0 text-uppercase">
											@if (!getFormControl(itemFormGroup, 'id').value) {
												@if (getFormControl(itemFormGroup, 'selectProduct').value?.name) {
													<b>{{ iItem + 1 }} -</b>
													{{ getFormControl(itemFormGroup, 'selectProduct').value?.name }}
												} @else {
													<b>Item {{ iItem + 1 }}</b>
												}
											}
										</p>
									</div>
									<div class="col-md-12">
										@if (hasItemSubmitted(iItem)) {
											<small class="text-info fw-700">
												<div class="spinner-border spinner-border-sm pe-1" role="status">
													<span class="visually-hidden">Loading...</span>
												</div>
												Processando o formulário, aguarde...
											</small>
										}

										<ng-template #alerts let-notification="notification">
											@if (notification?.message) {
												<small
													class="fw-600"
													[class.text-danger]="notification?.type === 'error'"
													[class.text-secondary]="notification?.type === 'success'">
													@if (notification?.type === 'error') {
														<b>Error:</b>
													}
													{{ notification?.message }}
												</small>
											}
										</ng-template>
										<ng-container *ngTemplateOutlet="alerts; context: { notification: hasNotification(iItem) }"></ng-container>
									</div>
								</div>
							</div>

							<div ngbAccordionCollapse>
								<div ngbAccordionBody>
									<ng-template>
										<div class="row animated animated--fade-in" [formGroup]="getFormGroup(itemFormGroup)">
											<div class="col-md-6 mb-3">
												<ng-select
													class="ng-custom-select ng-floating xl"
													[addTag]="true"
													bindLabel="name"
													appTextLimited
													[limited]="2000"
													[minTermLength]="3"
													[items]="product$ | async"
													[loading]="productLoading"
													[typeahead]="productInput$"
													loadingText="Carregando..."
													placeholder="Produto/Serviço"
													formControlName="selectProduct"
													notFoundText="Nenhum registro..."
													addTagText="Cadastrar produto ou serviço"
													typeToSearchText="Favor informe 3 ou mais caracteres para consultar"
													[class.is-invalid]="getFormControlInvalid(itemFormGroup, 'selectProduct')">
													<ng-template ng-option-tmp let-item="item" let-search="searchTerm">
														<p class="mb-0">
															<ngb-highlight [term]="search" [result]="item.name"></ngb-highlight>
														</p>
														<small class="text-muted">{{ item.description }}</small>
													</ng-template>
												</ng-select>
												@if (getFormControl(itemFormGroup, 'selectProduct').hasError('required')) {
													<div class="invalid-feedback">Informe o produto</div>
												}
											</div>

											<div class="col-md-2 col-sm-12 mb-3">
												<ng-select
													class="ng-custom-select ng-floating xl"
													placeholder="Unidade"
													formControlName="unit"
													[class.is-invalid]="getFormControlInvalid(itemFormGroup, 'unit')">
													@for (item of label.productUnits; track item.value) {
														<ng-option [value]="item.value">{{ item.label }}</ng-option>
													}
												</ng-select>
												@if (getFormControl(itemFormGroup, 'unit').hasError('required')) {
													<div class="invalid-feedback">Informe a unidade</div>
												}
											</div>

											<div class="col-md-2 col-sm-12 mb-3">
												<div class="form-floating">
													<input
														class="form-control"
														decimalMarker=","
														[leadZero]="true"
														mask="separator.2"
														formControlName="total"
														placeholder="Quantidade"
														[class.is-invalid]="getFormControlInvalid(itemFormGroup, 'total')"
														#inputItemTotal />
													<label>Quantidade</label>
													@if (getFormControl(itemFormGroup, 'total').hasError('required')) {
														<div class="invalid-feedback">Informe a quantidade</div>
													}
												</div>
											</div>

											<div class="col-md-2 col-sm-12 mb-3">
												<div class="form-floating">
													<input
														class="form-control"
														decimalMarker=","
														[leadZero]="true"
														prefix="R$ "
														mask="separator.2"
														formControlName="amount"
														placeholder="Valor Unitário"
														[class.is-invalid]="getFormControlInvalid(itemFormGroup, 'amount')" />
													<label>Valor Unitário</label>
													@if (getFormControl(itemFormGroup, 'amount').hasError('required')) {
														<div class="invalid-feedback">Informe o valor unitário</div>
													}
												</div>
											</div>

											<div class="col-md-12 mb-3">
												<div class="form-floating">
													<textarea
														appTextLimited
														[limited]="10000"
														class="form-control"
														style="height: 100px"
														placeholder="Descrição"
														formControlName="specification"
														[class.is-invalid]="getFormControlInvalid(itemFormGroup, 'specification')"></textarea>
													<label>Descrição</label>
													@if (getFormControl(itemFormGroup, 'specification').hasError('required')) {
														<div class="invalid-feedback">Informe a descrição</div>
													}
												</div>
											</div>

											@if (isBatchBidType) {
												<div class="col-md-12 mb-3">
													<ng-select
														class="ng-custom-select ng-floating xl"
														placeholder="Lote"
														bindLabel="description"
														formControlName="batchId"
														[disabled]="noticeSessionBatches.length === 0">
														@for (batch of noticeSessionBatches; track batch.id) {
															<ng-option [value]="batch.id">{{ batch.externalCode }} - {{ batch.description }}</ng-option>
														}
													</ng-select>
													@if (noticeSessionBatches.length === 0) {
														<small class="text-muted">Nenhum lote cadastrado para seleção.</small>
													}
												</div>
											}

											<div class="col-md-12 d-flex justify-content-end">
												<button class="btn btn-sm btn-link pe-0" (click)="itemInputExtras = !itemInputExtras">
													{{ itemInputExtras ? 'Não incluir' : 'Incluir' }} mais detalhes
												</button>
											</div>

											@if (itemInputExtras) {
												<div class="col-md-12 mb-3">
													<ng-select
														class="ng-custom-select xl ng-floating"
														[multiple]="true"
														bindLabel="label"
														[minTermLength]="3"
														placeholder="Classe"
														loadingText="Carregando..."
														notFoundText="Nenhum registro..."
														formControlName="productClasses"
														[items]="productClasses$ | async"
														[loading]="productClassesLoading"
														[typeahead]="productClassesInput$"
														typeToSearchText="Favor informe 3 ou mais caracteres para consultar">
														<ng-template ng-option-tmp let-item="item" let-search="searchTerm">
															<p class="mb-0 fw-500 text-wrap" style="line-height: normal">
																<ngb-highlight [term]="search" [result]="item.label"></ngb-highlight>
															</p>
															<small
																class="badge badge-sm bg-light border-primary text-primary fw-600 rounded-pill border-1 me-2">
																{{ item.className }}
															</small>
															<small
																class="badge badge-sm bg-light border-primary text-primary fw-600 rounded-pill border-1 me-2">
																{{ item.groupName }}
															</small>
															<small class="badge badge-sm bg-light border-primary text-primary fw-600 rounded-pill border-1">
																{{ label.fromProductClassGrouping(item.grouping)?.label }}
															</small>
														</ng-template>
													</ng-select>
												</div>

												<div class="col-md-12 mb-3">
													<ng-select
														class="ng-custom-select xl ng-floating"
														bindLabel="name"
														[multiple]="true"
														[minTermLength]="3"
														loadingText="Carregando..."
														notFoundText="Nenhum registro..."
														placeholder="Natureza da Despesa"
														[items]="productElements$ | async"
														[loading]="productElementsLoading"
														[typeahead]="productElementsInput$"
														formControlName="productSubElements"
														typeToSearchText="Favor informe 3 ou mais caracteres para consultar">
														<ng-template ng-option-tmp let-item="item" let-search="searchTerm">
															<p class="mb-0 fw-600 text-wrap" style="line-height: normal; padding-top: 6px">
																<ngb-highlight [term]="search" [result]="item.name"></ngb-highlight>
															</p>
															<small
																class="badge badge-sm bg-light border-primary text-primary fw-600 rounded-pill border-1 me-2">
																{{ item.externalCode }}
															</small>
														</ng-template>
													</ng-select>
												</div>
											}
										</div>
									</ng-template>
								</div>
							</div>
						</div>
					}
				</div>
			</form>
		}
	</div>
	<div class="modal-footer">
		<div class="d-flex w-100 justify-content-end align-content-center">
			@if (id && !listableItems) {
				<button class="btn btn-link me-2 text-danger" (click)="cancelFormItem()">Cancelar</button>

				@if (demandIntentDocumentItem) {
					<button *permissions="'planning.item.update'" class="btn btn-primary fw-600" (click)="updateItem()" [disabled]="submitted || demand?.statusCanceled">
						<app-label-loading-dots [loading]="submitted" label="Atualizar"></app-label-loading-dots>
					</button>
				} @else {
					<button *permissions="'planning.item.create'"
						class="btn btn-primary fw-600"
						(click)="modalFromAddVerifyItems()"
						[disabled]="submitted || readSheetForImportItemsLoading || demand?.statusCanceled">
						<app-label-loading-dots [loading]="submitted" label="Salvar"></app-label-loading-dots>
					</button>
				}
			} @else {
				<button class="btn btn-link me-2" (click)="modal.dismiss()">
					<fa-icon icon="reply" class="me-2"></fa-icon>
					Voltar
				</button>

				@if (!id) {
					<button *permissions="'planning.item.create'" class="btn btn-primary fw-600" (click)="modalFromAddVerifyItems()" [disabled]="submitted || readSheetForImportItemsLoading">
						<app-label-loading-dots [loading]="submitted || readSheetForImportItemsLoading" label="Confirmar"></app-label-loading-dots>
					</button>
				}
			}
		</div>
	</div>
</ng-template>
